import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { priceDataCurrencySymbol } from './ListingPage.shared';
import { displayPrice } from '../../util/configHelpers';
import { H4 } from '../../components';

import css from './ListingPage.module.css';
import { PRICE_TYPE } from '../../constants/global.constants';
import { LISTING_STATUS } from '../../constants/listing.constants';

const SectionPrice = props => {
  const { listing } = props;
  const { price, publicData } = listing.attributes || {};
  const { listingType, vatIncluded, status, priceType, saleClass } = publicData || {};
  const config = useConfiguration();
  const intl = useIntl();

  const vatNotIncluded = !vatIncluded || vatIncluded === 'no' || vatIncluded === '0';

  const showPrice = displayPrice(
    config.listing.listingTypes.find(conf => conf.listingType === listingType)
  );

  const { formattedPrice, priceTitle } = priceDataCurrencySymbol(price, config.currency, intl);

  const noPrice =
    status === LISTING_STATUS.UNDER_NEGOTIATION ||
    status === LISTING_STATUS.SOLD ||
    status === LISTING_STATUS.UNAVAILABLE;

  if (!showPrice || !price || noPrice) {
    return null;
  }

  if (priceType === PRICE_TYPE.ON_REQUEST || priceType === PRICE_TYPE.AUCTION) {
    return (
      <section className={css.sectionPrice}>
        <H4 className={css.price} title={priceTitle}>
          <FormattedMessage id={`General.price.priceType.${priceType}`} />
        </H4>
      </section>
    );
  }

  return (
    <section className={css.sectionPrice}>
      {!noPrice && (
        <div className={css.sectionPriceValue}>
          <H4 className={css.price} title={priceTitle}>
            {formattedPrice}
          </H4>
          <span className={css.vatIncluded}>
            {vatNotIncluded ? (
              <FormattedMessage id="ListingPage.price.vatNotIncluded" />
            ) : (
              <FormattedMessage id="ListingPage.price.vatIncluded" />
            )}
            {saleClass ? (
              <>
                {' '}
                • <FormattedMessage id={`General.listing.saleClass.${saleClass}`} />
              </>
            ) : null}
          </span>
        </div>
      )}
    </section>
  );
};

export default SectionPrice;
